import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { NewsCard } from './NewsCard';
import { useUserContext } from '../../components/UserData';
import { isUrlTrusted } from '../../utils/urlValidator';
import './index.scss';

const Root = styled.div`
  padding-bottom: 80px;
  width: 1200px;
  margin: auto;
  &.news-list {
    margin-top: 80px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background-color: #f4f4f4;
    .news-card {
      margin-bottom: 20px;
      width: 100%;
    }
  }
  &.article {
    margin-top: 80px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background-color: #f4f4f4;
    //margin-top: 80px;
  }
`;

const Trend = () => {
  const { state, update } = useUserContext((t) => [t.frameUrl, t.articles]);
  const list = state.articles;
  const history = useHistory();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <Root className="news-list">
      {list.map((item) => {
        const {
          img, title, desc, time, url, fromConfig,
        } = item;
        // eslint-disable-next-line react/no-array-index-key
        return (
          <NewsCard
            img={img}
            title={title}
            desc={desc}
            time={time}
            key={`${title}-${url}`}
            onClick={() => {
              if (fromConfig) {
                window.open(url, '_blank');
              } else {
                update((t) => (t.frameUrl = url));
                // 只有通过安全校验的 URL 才能进入 iframe 展示
                if (isUrlTrusted(url)) {
                  const link = encodeURIComponent(url);
                  history.push({ pathname: '/trend/detail', search: `pageLink=${link}` });
                }
              }
            }}
          />
        );
      })}
    </Root>
  );
};

export default Trend;
